










import { getFederationComponent } from '@src/federations/getFederationComponent';
import { defineComponent } from '@vue/composition-api';
import SdsPageHeader from '@shared/components/pageHeader/SdsPageHeader.vue';
import { capitalize } from '@superbet-group/web.lib.utilities';
import { useI18n } from '@superbet-group/web.lib.vue-utilities';
import { useHasSocialRouteGuard } from '@socialFederation/helpers';

export default defineComponent({
    name: 'ChatPlaceholderContainer',
    setup() {
        useHasSocialRouteGuard();

        const { translate } = useI18n();

        const title = capitalize(translate('pam.accountMenu.chat'));

        return { title };
    },
    components: {
        SdsPageHeader,
        SuperSocialPrivateChat: getFederationComponent(() => import('social/PrivateChat')),
    },
});
